function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { sdkLogger } from '../../logger';
import { AdBreakTimeAdapter } from '../../players/bolt-ons/ad-break-time-adapter';
import { toAdBreaksWithPositionIncludingAds } from './ad-break-time-conversion';
function floor(x, decimalPlaces) {
    var exponent = decimalPlaces;
    return Math.floor(x * Math.pow(10, exponent)) / Math.pow(10, exponent);
}
export var AdPolicyManagerContentTimeAdapter = /*#__PURE__*/ function() {
    "use strict";
    function AdPolicyManagerContentTimeAdapter(adPolicyManager, playbackType) {
        var _this = this;
        _class_call_check(this, AdPolicyManagerContentTimeAdapter);
        _define_property(this, "adPolicyManager", void 0);
        _define_property(this, "playbackType", void 0);
        _define_property(this, "adBreakTimeAdapter", void 0);
        _define_property(this, "logger", void 0);
        _define_property(this, "shouldPlayAdBreak", void 0);
        this.adPolicyManager = adPolicyManager;
        this.playbackType = playbackType;
        this.logger = sdkLogger.withContext('APMCTA');
        this.shouldPlayAdBreak = function(adBreakWithContentPosition, contentPosition, isResumingFromBookmark) {
            if (!_this.adBreakTimeAdapter) {
                _this.logger.error('shouldPlayAdBreak was queried before ad breaks were provided');
                return false;
            }
            var adBreakWithPositionIncludingAds = _this.adBreakTimeAdapter.adBreakContentPositionToPositionIncludingAds(adBreakWithContentPosition);
            var positionIncludingAds = _this.adBreakTimeAdapter.contentTimeToTimeIncludingAds(contentPosition);
            return _this.adPolicyManager.shouldPlayAdBreak(adBreakWithPositionIncludingAds, positionIncludingAds, isResumingFromBookmark);
        };
    }
    _create_class(AdPolicyManagerContentTimeAdapter, [
        {
            key: "setAdBreaksData",
            value: function setAdBreaksData(adBreaks) {
                var adBreaksWithPositionsIncludingAds = toAdBreaksWithPositionIncludingAds(adBreaks);
                this.adBreakTimeAdapter = new AdBreakTimeAdapter(this.playbackType);
                this.adBreakTimeAdapter.initialise(adBreaksWithPositionsIncludingAds);
                this.adPolicyManager.setAdBreaksData(adBreaksWithPositionsIncludingAds);
            }
        },
        {
            key: "getAdBreaks",
            value: function getAdBreaks() {
                var _this = this;
                if (!this.adBreakTimeAdapter) {
                    return [];
                }
                var adBreaksWithPositionIncludingAds = this.adPolicyManager.getAdBreaks();
                var adBreaksWithContentPosition = adBreaksWithPositionIncludingAds.map(function(adBreak) {
                    return _this.adBreakTimeAdapter.adBreakPositionIncludingAdsToContentPosition(adBreak);
                });
                return adBreaksWithContentPosition;
            }
        },
        {
            key: "onShouldSeek",
            value: function onShouldSeek(callback) {
                var _this = this;
                this.adPolicyManager.onShouldSeek(function(postAdSeekPositionIncludingAds) {
                    if (!_this.adBreakTimeAdapter) {
                        _this.logger.error('onShouldSeek called before setAdBreaksData was called');
                        return;
                    }
                    callback(_this.adBreakTimeAdapter.timeIncludingAdsToContentTime(postAdSeekPositionIncludingAds));
                });
            }
        },
        {
            key: "manageSeek",
            value: function manageSeek(currentContentPosition, contentSeekToPosition, clearPostAdSeekPosition) {
                if (!this.adBreakTimeAdapter) {
                    return contentSeekToPosition;
                }
                var currentContentPositionIncludingAds = this.adBreakTimeAdapter.contentTimeToTimeIncludingAds(currentContentPosition);
                var seekToPositionIncludingAds = this.adBreakTimeAdapter.contentTimeToTimeIncludingAds(contentSeekToPosition);
                var managedPositionIncludingAds = this.adPolicyManager.manageSeek(currentContentPositionIncludingAds, seekToPositionIncludingAds, clearPostAdSeekPosition);
                return floor(this.adBreakTimeAdapter.timeIncludingAdsToContentTime(managedPositionIncludingAds), 2);
            }
        },
        {
            key: "seekEnded",
            value: function seekEnded() {
                this.adPolicyManager.seekEnded();
            }
        },
        {
            key: "seekStarted",
            value: function seekStarted() {
                this.adPolicyManager.seekStarted();
            }
        },
        {
            key: "manageStartPosition",
            value: function manageStartPosition(contentTimeStartPosition) {
                if (!this.adBreakTimeAdapter) {
                    return contentTimeStartPosition;
                }
                var startPositionIncludingAds = this.adBreakTimeAdapter.contentTimeToTimeIncludingAds(contentTimeStartPosition);
                var managedStartPositionIncludingAds = this.adPolicyManager.manageStartPosition(startPositionIncludingAds);
                return floor(this.adBreakTimeAdapter.timeIncludingAdsToContentTime(managedStartPositionIncludingAds), 2);
            }
        },
        {
            key: "manageAdBreakStarted",
            value: function manageAdBreakStarted(adBreakWithContentPosition) {
                if (!this.adBreakTimeAdapter) {
                    this.logger.error('manageAdBreakStarted was called before setAdBreaksData was called');
                    return adBreakWithContentPosition;
                }
                var adBreakWithPositionIncludingAds = this.adBreakTimeAdapter.adBreakContentPositionToPositionIncludingAds(adBreakWithContentPosition);
                var managedAdBreakWithPositionIncludingAds = this.adPolicyManager.manageAdBreakStarted(adBreakWithPositionIncludingAds);
                return this.adBreakTimeAdapter.adBreakPositionIncludingAdsToContentPosition(managedAdBreakWithPositionIncludingAds);
            }
        },
        {
            key: "manageAdBreakFinished",
            value: function manageAdBreakFinished(adBreakWithContentPosition) {
                if (!this.adBreakTimeAdapter) {
                    this.logger.error('manageAdBreakFinished was called before setAdBreaksData was called');
                    return adBreakWithContentPosition;
                }
                var adBreakWithPositionIncludingAds = this.adBreakTimeAdapter.adBreakContentPositionToPositionIncludingAds(adBreakWithContentPosition);
                var managedAdBreakWithPositionIncludingAds = this.adPolicyManager.manageAdBreakFinished(adBreakWithPositionIncludingAds);
                return this.adBreakTimeAdapter.adBreakPositionIncludingAdsToContentPosition(managedAdBreakWithPositionIncludingAds);
            }
        },
        {
            key: "manageAdStarted",
            value: function manageAdStarted(ad) {
                return this.adPolicyManager.manageAdStarted(ad);
            }
        },
        {
            key: "manageAdFinished",
            value: function manageAdFinished(ad) {
                return this.adPolicyManager.manageAdFinished(ad);
            }
        }
    ]);
    return AdPolicyManagerContentTimeAdapter;
}();

//# sourceMappingURL=ad-policy-manager-content-time-adapter.js.map